import { ApiItemEstoque } from '../@types';
import aqilaApi from './aqila-api';

class ItensEstoque {
  private readonly endpoint = '/v1/itens';

  async estoques({ propriedadeId, operacaoItem, noPaginate }: EstoquesParams) {
    const params = {
      operacaoItem,
      propriedade: propriedadeId,
      noPaginate,
    };

    const {
      data: { data },
    } = await aqilaApi.get<{ data: ApiItemEstoque[] }>(this.endpoint, {
      params,
    });

    return data.map((item) => item.attributes);
  }
}

type OperacaoItem =
  | 'insumo'
  | 'produto'
  | 'combustivel'
  | 'pecas'
  | 'cultivar'
  | 'diversos'
  | 'maquinas'
  | 'benfeitorias'
  | 'adubacao'
  | 'pulverizacao';

type EstoquesParams = {
  propriedadeId: number;
  operacaoItem: OperacaoItem;
  noPaginate?: boolean;
};

export default new ItensEstoque();
